export type DashboardView = 'rows' | 'cards';

interface Props {
  value: DashboardView;
  onChange: (v: DashboardView) => void;
}

const options: { value: DashboardView; label: string; path: string }[] = [
  { value: 'rows', label: 'Rows', path: 'M4 6h16M4 12h16M4 18h16' },
  { value: 'cards', label: 'Cards', path: 'M4 5h6v6H4zM14 5h6v6h-6zM4 13h6v6H4zM14 13h6v6h-6z' },
];

export function ViewToggle({ value, onChange }: Props) {
  return (
    <div
      className="inline-flex rounded-md border border-gray-300 dark:border-gray-600 overflow-hidden shrink-0"
      role="group"
      aria-label="Dashboard layout"
    >
      {options.map(o => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            aria-pressed={active}
            title={`${o.label} view`}
            className={`px-2.5 py-2 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-500 ${
              active
                ? 'bg-brand-600 text-white'
                : 'bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
            }`}
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d={o.path} />
            </svg>
            <span className="sr-only">{o.label} view</span>
          </button>
        );
      })}
    </div>
  );
}
